// packages/shared-hooks/src/engagements/useToggleLeadChecklistItem.ts
//
// `PATCH /leads/:id/checklist/:itemId` (#2317 D-2) — toggle a CLOSING checklist
// item on the projected engagement by lead id. Reuses the native
// `PatchChecklistItemInput` body and returns the full `ChecklistView` (200).
// Item 7 (`confirm_payment`) is blocked server-side (409) and never toggled
// from the card. Success flushes the checklist read (keyed by engagement id)
// and the `detailByLead` projection prefix so the card refreshes in place.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ChecklistViewSchema,
  type ChecklistView,
  type PatchChecklistItemInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { engagementsKeys } from './keys.js';

export function useToggleLeadChecklistItem(leadId: string, engagementId: string, itemId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<ChecklistView, unknown, PatchChecklistItemInput>({
    mutationFn: (input) =>
      client.patch<ChecklistView>(
        `/leads/${leadId}/checklist/${itemId}`,
        input,
        {},
        ChecklistViewSchema,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: engagementsKeys.checklist(engagementId) });
      void qc.invalidateQueries({ queryKey: engagementsKeys.detailByLead(leadId) });
    },
  });
}
